import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import { withNamespaces } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import grey from '@material-ui/core/colors/grey';
import NavigationBar from '../components/NavigationBar';
import List from '../components/List';
import Map from '../components/Map';
import Error from '../components/Error';
import NotFoundAddressesDialog from '../components/dialogs/NotFoundAddressesDialog';
import NotGeolocatedAddressesDialog from '../components/dialogs/NotGeolocatedddressesDialog';
import { snackbarRouteCannotBeEdited, snackbarNotFoundAddresses, snackbarNotGeoAddresses } from '../helpers/snackbars';
import { STATUS, status } from '../store/status';
import { MODES, mode } from '../store/mode';
import { downloadRoutePage } from '../helpers/api';

class SortRoute extends Component {
  constructor(props) {
    super(props);
    this.state = { openDialogs: { notFound: false, notGeo: false } };
  }

  openDialog(name) {
    this.setState({ openDialogs: Object.assign(this.state.openDialogs, { [name]: true }) });
  }

  closeDialog(name) {
    this.setState({ openDialogs: Object.assign(this.state.openDialogs, { [name]: false }) });
  }

  componentDidMount() {
    const { t, enqueueSnackbar } = this.props;
    const { uid, code } = this.props.match.params;
    downloadRoutePage({ uid, code })
      .then((downloadedRoutePage) => {
        const notFoundCount = downloadedRoutePage.notFoundStops.length;
        if (notFoundCount > 0) {
          snackbarNotFoundAddresses({ t, enqueueSnackbar, count: notFoundCount, onViewClick: () => this.openDialog('notFound') });
        }
        const notGeoCount = downloadedRoutePage.notGeolocatedStops.length;
        if (notGeoCount > 0) {
          snackbarNotGeoAddresses({ t, enqueueSnackbar, count: notGeoCount, onViewClick: () => this.openDialog('notGeo') });
        }
        if (!downloadedRoutePage.editable) {
          snackbarRouteCannotBeEdited({ t, enqueueSnackbar });
        }
      })
      .catch(() => {});
  }

  static onContextMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  }

  render() {
    const { t, width, match: { params: { uid, code } } } = this.props;
    const { openDialogs: { notFound: isNotFoundOpen, notGeo: isNotGeoOpen } } = this.state;
    const isScreenSmall = isWidthDown('sm', width);
    const hideList = mode.get() === MODES.MAP;
    const hideMap = mode.get() === MODES.LIST;
    const listStyle = {
      display: isScreenSmall && hideList ? 'none' : 'block',
      flexGrow: isScreenSmall ? 1 : 0,
      flexShrink: 0,
      width: isScreenSmall ? '100%' : '384px',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      backgroundColor: grey[200],
      borderRight: isScreenSmall ? 'none' : `1px solid ${grey[900]}`,
    };
    const mapStyle = {
      display: isScreenSmall && hideMap ? 'none' : 'block',
      position: 'relative',
      flexGrow: 1,
      flexShrink: 0,
    };
    switch (status.get()) {
      case STATUS.LOADING:
        return (
          <Grid container justify="center" alignItems="center" style={{ height: '100vh' }}>
            <Grid item>
              <CircularProgress/>
            </Grid>
          </Grid>
        );
      case STATUS.FOUND:
        return (
          <div onContextMenu={SortRoute.onContextMenu}>
            <Grid container direction="column" wrap="nowrap" style={{ width: '100%' }}>
              <Grid item>
                <NavigationBar uid={uid} code={code}/>
              </Grid>
              <Grid item container wrap="nowrap" style={{ flewGrow: 1, width: '100%', height: 'calc(100vh - 56px)' }}>
                <Grid item style={listStyle}>
                  <List/>
                </Grid>
                <Grid item style={mapStyle}>
                  <Map/>
                </Grid>
              </Grid>
            </Grid>
            <NotFoundAddressesDialog open={isNotFoundOpen} onClose={() => this.closeDialog('notFound')}/>
            <NotGeolocatedAddressesDialog open={isNotGeoOpen} onClose={() => this.closeDialog('notGeo')}/>
          </div>
        );
      case STATUS.NOT_FOUND:
        return <Error>{t('messages.errors.notFound', { code })}</Error>;
      case STATUS.ERROR_UNAUTHORIZED:
        return <Error>{t('messages.errors.unauthorized', { code })}</Error>;
      case STATUS.ERROR_OTHER:
        return <Error>{t('messages.errors.unknown', { code })}</Error>;
      default:
        return null;
    }
  }
}

SortRoute.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  width: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      uid: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
    }),
  }),
};

export default withSnackbar(withNamespaces()(withWidth()(observer(SortRoute))));



// WEBPACK FOOTER //
// ./src/pages/SortRoute.js